import React, { useEffect, useState } from "react";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";
import TooltipText from "../TooltipText";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { loadConfigurationData } from "../../../../../handlers/ClientDetail/Configurations Setup/configurationsHandler";
import { DisplayMsg } from "../../../../../services/toastService";
import { FetchData, UpdateData } from "../../../../../utils/array";
import {
  CONFIG_DATA,
  INITIAL_SYSTEM_OPTIONS,
  SYS_OPTION_DATA,
} from "../../../../../constants/configurations";
import ConfigurationToggleItem from "./ConfigurationToggleItem";
import { isInputDisabled, setUrl } from "../../../../../handlers";

const Configration = () => {
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const dispatch = useDispatch();
  const [detail, setDetail] = useState(null);
  const [Boxes, setBoxes] = useState({
    Visit: "",
    Future: "",
    message: "",
    check: false,
  });

  const [reload, setReload] = useState(false);
  // const { configData, systemOptions, featureOptions } = useConfigData(sharedData, dispatch, reload);

  const [configData, setConfigData] = useState([]);
  const [systemOptions, setSystemOptions] = useState([]);
  const [featureOptions, setFeatureOptions] = useState([]);

  const [confirm, setConfirm] = useState(false);
  const disabled = isInputDisabled();
  const [toggleObj, setToggleObj] = useState(null);

  useEffect(() => {
    if (!sharedData.currentClientId) return;

    const fetchConfigData = async () => {
      const config = await loadConfigurationData(sharedData.currentClientId, dispatch);
      if (config && !config?.succeeded) {
        DisplayMsg("2", config.Message)
      }
      else {
        setConfigData(config.configureData || []);
        setFeatureOptions(config.featureOptionData || []);
      }
    };

    fetchConfigData();
    fetchSystemOptions();
  }, [sharedData, dispatch, reload]);

  const fetchSystemOptions = async () => {
    try {
      const response = await FetchData(
        `Practice/${sharedData.currentEntityId}/sysoptions`,
        "PEHR",
        null,
        sharedData.clientApiKey
      );
      if (response && response.succeeded) {
        if (response.data) {
          setSystemOptions(
            INITIAL_SYSTEM_OPTIONS.map((entry) => ({
              ...entry,
              visible: response.data[entry.flag] === "0" ? "N" : response.data[entry.flag],
            }))
          );
        }
        document.getElementById("loader").style.display = "none";
      }
      else if (response && response.Message && response.Message.includes("Invalid TNS key.")) {
        DisplayMsg("2", "Client is InActive, unable to connect to database");
      } else if (response && response.Errors && Array.isArray(response.Errors)) {
        const infraError = response.Errors.find(err => err.PropertyName === "Infrastructure" && err.ErrorMessage.includes("Object reference not set to an instance of an object."));
        if (infraError) {
          DisplayMsg("2", "Its a Enterprise Client and doesn't have directly DB Access");
        } else {
          DisplayMsg("2", response.Message);
        }
      } else {
        DisplayMsg("2", response.Message);
      }
    }
    catch (error) {
      document.getElementById("loader").style.display = "none";
      console.log("The current error is", error);
      // DisplayMsg("2", "⚠️ Ptient Api is unable to connect to server.");
      // DisplayMsg("2", "⚠️ Ptient Api is unable to connect to server.");
    }
  }

  const handleConfirm = () => {
    $(`#my_${toggleObj.item.flag}`)[0].checked = true;
    Confirm(true);
  };

  const handleCancel = () => {
    $(`#my_${toggleObj.item.flag}`)[0].checked = false;
  };

  const showToolTip = (text) => {
    setDetail(text);
  };

  const CloseTooltip = () => {
    setDetail(null);
  };

  const updateBoxValue = (value, title) => {
    if (title === "teleVisitPaymentAmount") {
      setBoxes((boxValue) => ({
        ...boxValue,
        Visit: value,
      }));
    } else if (title === "eligFutureDays") {
      setBoxes((boxValue) => ({
        ...boxValue,
        Future: value,
      }));
    }
  };


  const FilterFlagValue = (flag, type) => {
    if (type === "config") {
      const config = CONFIG_DATA.filter((item) => item.label === flag);
      return config[0].value;
    }

    if (type === "sysOptions") {
      const config = SYS_OPTION_DATA.filter((item) => item.label === flag);
      return config[0].value;
    }

    return null;
  };

  const Confirm = async (check) => {
    const { title, flag, visible, type, e } = toggleObj.item;
    if (!check) {
      revertCheckboxState(e);
      return;
    }

    if (!validateInputs(flag, visible)) return;

    document.getElementById("loader").style.display = "block";

    switch (type) {
      case "systemOptions":
        await handleSystemOption(flag, visible);
        break;
      case "advanceFeature":
        await handleAdvancedFeature(title, flag, visible);
        break;
      case "configuration":
        await handleConfigOption(flag, visible);
        break;
      default:
        console.warn("Your case name is incorrect please verify :",)
        break;
    }
    document.getElementById("loader").style.display = "none";
  }

  const handleSystemOption = async (flag, visible) => {

    let visibleValue = visible;
    if (flag === "eligFutureDays") {
      visibleValue = visible === "N" ? '' : Boxes.Future
    }

    const queryParams = new URLSearchParams({
      Flag: FilterFlagValue(flag, "sysOptions"),
      Visible: visibleValue,
    }).toString();

    const response = await UpdateData(
      `Practice/Configuration/${sharedData.currentEntityId}/systemOptions`,
      null,
      "PEHR",
      queryParams,
      sharedData.clientApiKey
    );

    handleResponse(response, false, "systemOptions", visibleValue);
  };


  const RefreshPractice = async () => {
    document.getElementById("loader").style.display = "block";
    const result = await fetch(
      setUrl("PRACTICEDETAIL", "REFRESHPRACTICEDATA", true)
    );
    const response = await result.json();
    if (response && response.status) {
      return true;
    } else {
      return false;
    }
  };


  const handleAdvancedFeature = async (title, flag, visible) => {
    const payload = {
      AuthEntityId: sharedData.currentClientId,
      EntityId: sharedData.currentEntityId,
      FacilityId: sharedData.currentFacilityId === 0 ? "" : sharedData.currentFacilityId,
      Flag: title === "Web Kiosk" ? "webkiosk" : title,
      Visible: visible,
      AdvOptionId: flag,
      Type: "advancedFeatures",
      ClientApiKey: sharedData.clientApiKey,
    };

    const stringifiedPayload = stringifyValues(payload);
    const response = await UpdateData("Practice/updateAdvanceFeature", stringifiedPayload, "auth");

    if (response?.succeeded) {
      const featureData = [...featureOptions];
      const index = featureOptions.findIndex(item => item.advancedSeqNum === flag);
      if (index > -1) featureData[index].visible = visible;
      setFeatureOptions(featureData);
      DisplayMsg("1", response.message);
      const result = await RefreshPractice();
      console.log('result is', result)
    } else {
      DisplayMsg("2", response.message);
    }
  };

  const stringifyValues = (obj) =>
    Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, String(v)]));

  const handleConfigOption = async (flag, visible) => {

    let visibleValue = visible

    if (flag === "teleVisitPaymentAmount") {
      visibleValue = visible === "N" ? "" : Boxes.Visit;
    }

    const payload = {
      AuthEntityId: sharedData.currentClientId,
      EntityId: sharedData.currentEntityId,
      FacilityId: sharedData.currentFacilityId === 0 ? "" : sharedData.currentFacilityId,
      Flag: FilterFlagValue(flag, "config"),
      Visible: visibleValue,
      openTokSeceretKey: "",
      openTokApiKey: "",
    };

    const stringifiedPayload = stringifyValues(payload);

    const response = await UpdateData(
      "Practice/UpdateConfiguration",
      stringifiedPayload,
      "auth"
    );
    // handleResponse(response, false);

    if (response?.succeeded) {
      const configInfo = [...configData];
      const index = configInfo.findIndex(item => item.flag === flag);

      if (index === 12) {
        configInfo[index].visible = visibleValue === "" ? "N" : visibleValue;
      }

      if (index > -1 && index !== 12) configInfo[index].visible = visible;

      setConfigData(configInfo);
      DisplayMsg("1", response.message);
      const result = await RefreshPractice();
      console.log('Refresh is', result)
    } else {
      DisplayMsg("2", response.message);
    }

  };

  const handleResponse = (response, isSystemOption, type, visibleValue) => {
    if (!response) return;
    if (response.succeeded) {
      if (type === "systemOptions") {
        setBoxes((boxValue) => ({
          ...boxValue,
          Future: visibleValue === "" ? '' : Boxes.Future,
        }));
      }
      setReload((prev) => !prev);

      DisplayMsg("1", response.message);
    } else {
      DisplayMsg("2", response.message);
      $(".errorMessage").fadeIn(300).delay(1500).fadeOut(400);
    }
  };

  const revertCheckboxState = (e) => {
    if (!e?.target) return;
    e.target.checked = !e.target.checked;
  };

  const validateInputs = (flag, visible) => {
    if (flag === "eligFutureDays") {
      if (visible === "N") {
        setBoxes((b) => ({ ...b, Future: "" }));
        return true;
      }
      if (parseInt(Boxes.Future, 10) > 0 && visible === "Y") {
        return true;
      }
      DisplayMsg("2", Boxes.Future <= 0 ? "Number of days should be greater than 0" : "Set number of days");
      return false;
    }

    if (flag === "teleVisitPaymentAmount") {
      if (visible === "N") {
        setBoxes((b) => ({ ...b, Visit: "" }));
        visible = "";
        return true;
      }
      if (parseInt(Boxes.Visit, 10) > 0 && visible === "Y") {
        visible = Boxes.Visit;
        return true;
      }
      DisplayMsg("2", Boxes.Visit <= 0 ? "Payment amount should be greater than 0..." : "Set Payment amount...");
      return false;
    }

    return true;
  };

  const toggleFlag = (item, type) => {

    const updatedItem = { ...item };

    let textMessage = "";
    if (updatedItem.visible === "N" || updatedItem.visible === "n" || updatedItem.visible === null) {
      textMessage = "Are you sure you want to turn on this flag?";
      updatedItem.visible = "Y";
    } else {
      updatedItem.visible = "N";
      textMessage = "Are you sure you want to turn off this flag?";
    }

    setToggleObj(prevObj => ({
      ...prevObj,
      item: {
        ...updatedItem,
        type
      }
    }));

    setBoxes((boxesValue) => ({
      ...boxesValue,
      message: textMessage,
    }));
    setConfirm(true);
  };

  return (
    <>
      {detail && <TooltipText tooltip={detail} parentCallback={CloseTooltip} />}
      <>
        <div className="row">
          {
            configData && configData.length > 0 ?
              configData.map((item) => <ConfigurationToggleItem key={item.flag} type="configuration" boxValue={Boxes.Visit} item={item} disabled={disabled} onAmountChange={updateBoxValue} onToggle={toggleFlag} onTooltip={showToolTip} />)
              :
              <div>No Record Found</div>
          }
        </div>

        <div className="row table-panel-header">
          <div className="col-md-12 col-sm-12">
            <h6>System Options </h6>
          </div>
        </div>
        <div className="row">
          {
            systemOptions && systemOptions.length > 0 ?
              systemOptions.map((item) => <ConfigurationToggleItem key={item.flag} type="systemOptions" boxValue={Boxes.Future} item={item} disabled={disabled} onToggle={toggleFlag} onAmountChange={updateBoxValue} onTooltip={showToolTip} />)
              :
              <div>No Record Found</div>
          }
        </div>
        <div className="row table-panel-header">
          <div className="col-md-12 col-sm-12">
            <h6>
              Advance Features <span className="text-lg text-red-500">*</span>{" "}
            </h6>
          </div>
        </div>
        <div className="row">
          {
            featureOptions && featureOptions.length > 0 ?
              featureOptions.map((item) => <ConfigurationToggleItem key={item.flag} type="advanceFeature" item={item} disabled={disabled} onAmountChange={updateBoxValue} onToggle={toggleFlag} onTooltip={showToolTip} />)
              :
              <div>No Record Found</div>
          }
        </div>

        <ConfirmDialog
          visible={confirm}
          onHide={() => setConfirm(false)}
          message={Boxes.message}
          header="Please Confirm"
          accept={handleConfirm}
          reject={handleCancel}
        />
      </>
    </>
  );
};
export default Configration;
